import React,{Component} from "react";
import socketIOClient from "socket.io-client";
import {socketUrl} from "../RequestManager";
var socket;

class Header extends Component {
  constructor() {
    super();
    socket = socketIOClient(socketUrl, {
        transports: ["websocket"],
        autoConnect: true,
      });

  }
render() {
    return (
      <div></div>
    );
  }
}



export { Header, socket };
